import * as React from 'react'
import { LinkButton, toast } from '@sales-center/components'
import { MatchCreateNewButtonProps } from './typings'
import { useDialogState } from '@user/utils/useDialogState'
import { FullScreenDialog } from '@user/components/FullScreenDialog'
import { MatchCreateNewTabs } from './MatchCreateNewTabs'
import { permissionDenied } from '@user/store/authorization/permissions'
import { useMatchLocationTitles } from './hooks/useMatchLocationTitles'

export const MatchCreateNewButton: React.FC<MatchCreateNewButtonProps> = (
  props,
) => {
  const { canUpdateEntity, entityId } = props

  const [open, onOpen, onClose] = useDialogState()

  const onClick = React.useCallback(() => {
    if (canUpdateEntity) onOpen()
    else toast.error(permissionDenied)
  }, [canUpdateEntity, onOpen])

  const { matchLocationTitle } = useMatchLocationTitles()

  return (
    <>
      <LinkButton
        onClick={onClick}
        dataTestId={`match-new-location-${entityId}`}
      >
        {matchLocationTitle}
      </LinkButton>

      <FullScreenDialog open={open} onClose={onClose} closeButtonText="Cancel">
        <MatchCreateNewTabs
          {...props}
          matchLocationTitle={matchLocationTitle}
          onClose={onClose}
        />
      </FullScreenDialog>
    </>
  )
}
MatchCreateNewButton.displayName = 'MatchCreateNewButton'
